import { DialogConfirmOptions, MessageType } from '@caslink/common-client';
import { DialogService } from '@caslink/common-client/ng-app/dialog-service/dialog.service';
import { IChangeCommunicationModuleRequest } from '../models/change-communication-module-request';
import { IDeviceStatusListSummary } from '../models/device-status-list-summary.interface';
import { DeviceStatusLoadedLocationBaseComponent } from './device-status-loaded-location-base.component';
import { DeviceStatusService } from '../services/device-status.service';
import * as _ from 'lodash';

export abstract class DeviceStatusViewBaseComponent extends DeviceStatusLoadedLocationBaseComponent {
    public abstract deviceStatusService: DeviceStatusService;
    public abstract dialogService: DialogService;

    public currentItem: IDeviceStatusListSummary;
    public currentItemState: IDeviceStatusListSummary;

    public abstract getData(): angular.IPromise<any>;

    public cancelEdit(item: IDeviceStatusListSummary) {
        this.currentItemState = _.cloneDeep(item);

        this.disableEditMode(item);
    }

    public abstract editDeviceConfiguration(item: IDeviceStatusListSummary);

    public saveEdit(item: IDeviceStatusListSummary) {
        if (item.moduleId !== this.currentItemState.moduleId) {
            this.deviceStatusService.promptCommModuleChange(
                {
                    category: item.category,
                    hardwareItemId: item.hardwareItem.id,
                    newMacAddress: item.macAddress,
                    previousMacAddress: this.currentItemState.macAddress,
                    sequence: item.sequence
                } as IChangeCommunicationModuleRequest,
                () => this.getData());
        } else {
            const options = {
                confirmBtnText: 'Yes',
                message: 'Would you really like to save this Device?',
                messageType: MessageType.Warning,
                showCancelBtn: true,
                title: 'Save?'
            } as DialogConfirmOptions;

            this.dialogService.showConfirmDialog({data: options})
                .afterClosed()
                .toPromise()
                .then(confirmed => {
                    if (confirmed) {
                        this.deviceStatusService.save(item)
                            .finally(() => this.getData());
                    }
                });
        }
    }

    public deleteDevice(item: IDeviceStatusListSummary) {
        const options = {
            confirmBtnText: 'Yes',
            message: 'Would you really like to remove this Device?',
            messageType: MessageType.Warning,
            showCancelBtn: true,
            title: 'Remove?'
        } as DialogConfirmOptions;

        this.dialogService.showConfirmDialog({data: options})
            .afterClosed()
            .toPromise()
            .then(confirmed => {
                if (confirmed) {
                    this.deviceStatusService
                        .delete(item)
                        .finally(() => this.getData());
                }
            });
    }

    private disableEditMode(item: IDeviceStatusListSummary) {
        this.currentItem = null;
        this.currentItemState = null;

        item.$isInEditMode = false;
    }
}
